import { MinusIcon, PlusIcon } from '@/components/icons';
import { ZoomControlButton } from '@/components/feature/floor-guide/zoom-control-button';
import { useTranslation } from 'react-i18next';
import { useOrientation } from '@/hooks';

type Props = {
    onZoomIn?: () => void;
    onZoomOut?: () => void;
    disabledZoomIn?: boolean;
    disabledZoomOut?: boolean;
    tabIndex?: number;
};

export const ZoomControlBtnGroup = ({ onZoomIn, onZoomOut, disabledZoomIn, disabledZoomOut, tabIndex }: Props) => {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();

    return (
        <section
            className="shadow-zoom-control-btn flex w-fit items-stretch justify-center rounded-l-md rounded-r-md"
            data-region-nav
            data-region-order={isHorizontal ? 9 : 5}
        >
            <ZoomControlButton
                tabIndex={tabIndex}
                role="button"
                aria-label={t('floor_guide.button.zoom_in_on_the_map')}
                data-interactive
                icon={<PlusIcon />}
                className="rounded-l-md"
                onClick={() => (disabledZoomIn ? undefined : onZoomIn?.())}
                aria-disabled={disabledZoomIn}
                data-role={t('common.data_role.button')}
            >
                {t('floor_guide.button.zoom_in')}
            </ZoomControlButton>

            <div className="bg-bg-gray-f4-to-dark w-[calc((5*var(--vh-unit)))]" />

            <ZoomControlButton
                tabIndex={tabIndex}
                role="button"
                aria-label={t('floor_guide.button.zoom_out_on_the_map')}
                data-interactive
                icon={<MinusIcon />}
                className="rounded-r-md"
                onClick={() => (disabledZoomOut ? undefined : onZoomOut?.())}
                aria-disabled={disabledZoomOut}
                data-role={t('common.data_role.button')}
            >
                {t('floor_guide.button.zoom_out')}
            </ZoomControlButton>
        </section>
    );
};
